import 'element-query/elementQuery';
import $ from 'jquery';
import '@fancyapps/fancybox';

// Expose jQuery to global scope
global.$ = global.jQuery = $;

import svg4everybody from 'svg4everybody';

// Utility
import urlparams from './utility/urlparams';
import ajaxHelpers from './utility/ajax-helpers';

// Components
import navigation from './components/navigation';
import breadcrumbs from './components/breadcrumbs';
import icons from './components/icons';
import lazyload from './components/lazy-load';
import imageLoader from './components/image-loader';
import form from './components/form';
import checkout from './components/checkout';
import { isSupportedBrowser } from '../supported-browsers';
import colorSelectBox from './components/color-select-box';
import carousel from './components/carousel';
import deliveryClickAndCollect from './components/delivery-click-and-collect';

// Add an alias to the app, if we need to call app from the outside:
window.app = window.app || {};

window.app.common = {
    dynamicImportModulesAfterCookieConsent() {

        // YOUTUBE
        if ($('[src-yt]').length) {
            import('./components/youtube').then((module) => module.default.init());
        }

        // YOUTUBE BACKGROUND
        if ($('[src-bg-yt]').length) {
            import('./components/youtube-background').then((module) => module.default.init());
        }

        // TRACKING
        if ($('[data-tracking-event]').length) {
            import('./b2b/tracking').then((module) => module.default.init());
        }
    },

    dynamicImportModules() {

        // SEARCH
        if ($('.search-hero, [data-categorylink], [data-categorysection]').length) {
            import('./components/search').then((module) => module.default.init());
        }

        // SEARCH HEADER
        if ($('.js-search-header').length) {
            import('./components/searchheader').then((module) => module.default.init());
        }

        // INFO BLOCK ICONS
        if ($('.info-block-icon').length) {
            import('./components/info-block-icon').then((module) => module.default.init());
        }

        // LIST ITEM LIMIT
        if ($('[data-listitemlimit]').length) {
            import('./components/list-item-limit').then((module) => module.default.init());
        }

        // ARTICLE GALLERY
        if ($('.article-gallery').length) {
            import('./components/article-gallery').then((module) => module.default.init());
        }

        // PAGE FILTERS
        if ($('[data-filterlist], .js-dropdown-single-select').length) {
            import('./components/page-filters').then((module) => module.default.init());
        }

        // AREA NAVIGATION
        if ($('.area-navigation-listwrap').length) {
            import('./components/area-navigation').then((module) => module.default.init());
        }

        // MAP
        if ($('#map').length) {
            import('./components/map/index').then((module) => module.default.init());
        }

        // FAQ
        if ($('.tipstricks-list').length) {
            import('./components/tipstricks').then((module) => module.default.init());
        }

        // SPLASHES
        if ($('.x-splash-content').length) {
            import('./components/splashes').then((module) => module.default.init());
        }

        // PREFILL CITY
        if ($('.js-prefill-city-source').length) {
            import('./components/prefill-city').then((module) => module.default.init());
        }

        // SEARCH TRACKING
        if ($('[data-trackquery]').length) {
            import('./components/search-tracking').then((module) => module.default.init());
        }

        // STOCK LOADER
        if ($('.js-atp-store-stock, .js-b2b-store-stock, .js-b2c-store-stock').length) {
            import('./components/stock-loader').then(({
                default: stockLoader
            }) => {
                stockLoader.init();
                window.app.stockLoader = stockLoader;
            });
        }

        // STORE STOCK LIST
        if ($('.js-store-stock-list-trigger').length) {
            import('./b2b/store-stock-list').then(({
                default: storeStockList
            }) => {
                storeStockList.init();
                window.app.storeStockList = storeStockList;
            });
        }

        // PRODUCT
        if ($('.js-product-add-to-cart').length) {
            import('./b2b/product').then(({
                default: product
            }) => {
                product.init('.js-product-add-to-cart');
                window.app.product = product;
            });
        }

        // FAV PRODUCT
        if ($('.js-fav-product-scope').length) {
            import('./b2b/favorite-product').then((module) => module.default.init('.js-fav-product-scope'));
        }

        // COLOR PICKER
        if ($('.js-color-picker').length) {
            import('./b2b/color-picker').then((module) => module.default.init());
        }

        if ($('[data-ajax]').length) {
            import('jquery-ajax-unobtrusive').catch((err) => {
                console.error(err);
            });
        }

        if ($('[data-inputmask], [data-inputmask-regex]').length) {
            import('./components/inputmask').then((module) => module.default.init());
        }

        // tabs
        if ($('.js-nemid').length) {
            import('./components/nemid-login').then((module) => module.default.init('.js-nemid'));
        }
		
		if ($('.js-mitid').length) {
            import('./components/mitid-login').then((module) => module.default.init('.js-mitid'));
        }

    },

    cookieInformationConsentGiven(hasNeededCookie) {
        if (!hasNeededCookie) return;

        this.dynamicImportModulesAfterCookieConsent();
    },

    init() {
        if (!isSupportedBrowser) {
            import('./components/outdated-browser.js')
                .then((module) => module.default.init())
                .catch((err) => {
                    console.error(err);
                });
        }

        console.log('%cINIT', 'padding:0 4px;background:#06966e;color:#fff', 'Flugger'); // eslint-disable-line no-console

        // SVG
        svg4everybody({ polyfill: true });

        // Init components
        navigation.init();
        breadcrumbs.init();
        icons.init();
        lazyload.init();
        imageLoader.init();
        carousel.init();
        form.init();
        checkout.init();
        deliveryClickAndCollect.init();

        this.dynamicImportModules();

        window.addEventListener('CookieInformationConsentGiven', () => window.app.common.cookieInformationConsentGiven(window.CookieInformation.getConsentGivenFor('cookie_cat_functional')), false);
        if (!window.CookieInformation) {
            window.app.common.cookieInformationConsentGiven(true);
        }

        window.app.ajax = ajaxHelpers;

        // Remove preload class
        $('body').removeClass('preload');

        // quick tempdisplay
        if (urlparams.getParameterByName('tempdisplay') === '1') {
            $('body').addClass('tempdisplay');
        }

        $('img').on('error', function() {
            $(this).attr('src', '/assets/gfx/paperfold.png');
        });

        colorSelectBox.init('.js-color-selectbox-wrapper');

    }
};

// jQuery document ready
$(() => window.app.common.init($));

// Legacy Modernizr support
((el) => {
    el.className = el.className.replace('no-js', 'js');
    el.className += ((('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) ? ' touchevents' : ' no-touchevents'); // eslint-disable-line no-undef
})(document.documentElement);
